// extracted by mini-css-extract-plugin
export default {"container":"FDtnt5","header":"Y0bxin","notPGLayout":"iNQ68R","notPgLayout":"iNQ68R","withPadding":"uKtW2I","menu":"XcjqVD"};